//export const getAuthToken = (state) => state.auth.authToken;
export const getIsLoggedIn = (state) => !!state.auth.clientHashId;